import { createContext } from "react";

export const CreateSmartPlanContext = createContext(null);
